import { apiFetch } from './client';

export const accountAPI = {
  create: (accountData) =>
      apiFetch('/accounts', {
        method: 'POST',
        body: JSON.stringify(accountData),
      }),

  getAll: () => apiFetch('/accounts'),

  getMy: () => apiFetch('/accounts/my'),

  getById: (id) => apiFetch(`/accounts/${id}`),

  getByUsername: (username) => apiFetch(`/accounts/username/${username}`),

  getByStatus: (status) => apiFetch(`/accounts/status/${status}`),

  update: (id, accountData) =>
      apiFetch(`/accounts/${id}`, {
        method: 'PUT',
        body: JSON.stringify(accountData),
      }),

  updateStatus: (id, status) =>
      apiFetch(`/accounts/${id}/status?status=${status}`, {
        method: 'PATCH',
      }),

  delete: (id) =>
      apiFetch(`/accounts/${id}`, {
        method: 'DELETE',
      }),

  refreshToken: (id) =>
      apiFetch(`/accounts/${id}/refresh-token`, {
        method: 'POST',
      }),

  validateToken: (id) =>
      apiFetch(`/accounts/${id}/validate-token`, {
        method: 'POST',
      }),

  getTokenInfo: (id) => apiFetch(`/accounts/${id}/token-info`),

  canPost: (id) => apiFetch(`/accounts/${id}/can-post`),

  getSchedule: (accountId) =>
      apiFetch(`/accounts/${accountId}/schedule`),

  updateSchedule: (accountId, scheduleData) =>
      apiFetch(`/accounts/${accountId}/schedule`, {
        method: 'PUT',
        body: JSON.stringify(scheduleData),
      }),

  addUploadTime: (accountId, time) =>
      apiFetch(`/accounts/${accountId}/schedule/time`, {
        method: 'POST',
        body: JSON.stringify({ time }),
      }),

  removeUploadTime: (accountId, time) =>
      apiFetch(`/accounts/${accountId}/schedule/time/${time}`, {
        method: 'DELETE',
      }),
};

export const contentSettingsAPI = {
  get: (accountId) => apiFetch(`/accounts/${accountId}/content-settings`),

  update: (accountId, data) =>
      apiFetch(`/accounts/${accountId}/content-settings`, {
        method: 'PUT',
        body: JSON.stringify(data),
      }),

  generateProfileSuggestion: (data) =>
      apiFetch('/accounts/generate-profile-suggestion', {
        method: 'POST',
        body: JSON.stringify(data),
      }),
};

export const customPromptAPI = {
  get: (accountId) => apiFetch(`/accounts/${accountId}/custom-prompt`),
  update: (accountId, data) =>
      apiFetch(`/accounts/${accountId}/custom-prompt`, {
        method: 'PUT',
        body: JSON.stringify(data),
      }),
  reset: (accountId) =>
      apiFetch(`/accounts/${accountId}/custom-prompt`, {
        method: 'DELETE',
      }),
};

export const instagramOAuthAPI = {
  getAuthorizeUrl: () => `${'/api'}/instagram/oauth/authorize`,

  disconnect: (accountId) =>
      apiFetch(`/instagram/oauth/${accountId}/disconnect`, {
        method: 'POST',
      }),
};
